<template>
  <v-sheet>
    <h4 class="form-title">로그인</h4>
    <p class="form-subtitle">
      이안드라이브 콘솔에 접근하실려면 아이디와 비밀번호를 입력해주세요
    </p>
    <template
      v-if="useFirebase">
      <v-btn
        color="primary"
        block
        large
        @click="signInWithGoogle">
        <v-icon left>mdi-google</v-icon>
        Google 계정으로 로그인
      </v-btn>
      <div class="text-center py-4">
        또는
      </div>
    </template>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @keyup.native.enter="signInWithEmailAndPassword">
      <label class="form-label">이메일</label>
      <v-text-field
        v-model="form.email"
        :rules="[
          rule.required,
          rule.minLength(5),
          rule.maxLength(50),
          rule.email
        ]"
        dense
        flat
        solo
        outlined
        placeholder="이메일을 입력해주세요">
      </v-text-field>
      <label class="form-label">비밀번호</label>
      <v-text-field
        type="password"
        v-model="form.passwd"
        :rules="[
          rule.required,
          rule.minLength(5),
          rule.maxLength(50)
        ]"
        class="mb-4"
        dense
        flat
        solo
        outlined
        placeholder="비밀번호를 입력해주세요">
      </v-text-field>
      <v-btn
        color="primary"
        depressed
        block
        large
        @click="signInWithEmailAndPassword">
        로그인
      </v-btn>
      <v-divider class="py-4"></v-divider>
      <v-btn
        color="primary"
        depressed
        outlined
        block
        large
        @click="$emit('changeType')">
        회원가입
      </v-btn>
    </v-form>
  </v-sheet>
</template>

<script>
import { mapState } from 'vuex'
import CONFIG from '@/config'

import { AuthAPI } from '@/api'

export default {
  data: () => ({
    valid: false,
    form: {
      email: '',
      passwd: ''
    },
    rule: {
      required: v => !!v || '필수 항목입니다',
      minLength: length => v =>
        v.length >= length || `${length}자리 이상으로 입력하세요.`,
      maxLength: length => v =>
        v.length <= length || `${length}자리 이하으로 입력하세요.`,
      email: v => /.+@.+/.test(v) || '이메일 형식에 맞지 않습니다.',
      agree: v => !!v || '약관에 동의해야 진행됩니다.'
    }
  }),

  computed: {
    useFirebase () {
      return CONFIG.USE_FIREBASE
    },

    ...mapState({
      claims: 'auth/claims'
    })
  },

  methods: {
    async signInWithGoogle () {
      const provider = new this.$firebase.auth.GoogleAuthProvider()
      this.$firebase.auth().languageCode = 'ko';
      await this.$firebase.auth().signInWithPopup(provider);
      const user = this.$firebase.auth().currentUser;
      await user.getIdToken();
      await this.$store.dispatch('auth/getUser', user);
      console.log('user', user);
      if (this.$store.state.auth.claims.level === undefined)
        return this.$router.push('/userProfile');
      this.$router.push('/');
    },

    async signInWithEmailAndPassword () {
      if (!this.$refs.form.validate()) {
        this.$toasted.global.error('아이디 혹은 비밀번호를 올바르게 작성해주세요')
        return false
      }

      if (this.useFirebase) {
        await this.$firebase
          .auth()
          .signInWithEmailAndPassword(
            this.form.email,
            this.form.passwd
          )
        const user = this.$firebase.auth().currentUser
        await user.getIdToken()
        await this.$store.dispatch('auth/getUser', user)
        if (!claims.level) {
          this.$router.push('/userProfile')
        } else {
          this.$router.push('/')
        }
      } else {
        const result = await AuthAPI.login(
          this.form.email,
          this.form.passwd
        )
        const data = result.data

        await this.$store.dispatch('auth/getUser', data.data)
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.form-title {
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0.875rem;
}

.form-subtitle {
  font-size: .9rem;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  margin-bottom: 2.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/signIn.vue